import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  message: {
    width: '80%',
    margin: '16px auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '100',
  },
}));
